






import { auth } from 'firebase/app';
import Vue from 'vue';

export default Vue.component('FacebookLogin',{
  name: 'FacebookLogin',
  props: {
    styleClass: String,
  },
  data() {
    return {
      errorMessage: '',
    };
  },
  methods: {
    facebook(): void {
      const provider = new auth.FacebookAuthProvider();
      auth().signInWithPopup(provider).then((result) => {
        this.$store.commit('setCurrentUser', result.user);
        this.$router.push(sessionStorage.getItem('redirectPath') || '/dreams');
        sessionStorage.removeItem('redirectPath');
      }).catch(error => {
        this.errorMessage = error.message;
        this.$emit('update:errorMessage', this.errorMessage);
      });
    },
  },
});
